module.exports = __webpack_public_path__ + "static/media/es.4210efe5.svg";